// eslint-disable-next-line import/no-anonymous-default-export
export default {
  license: {
    common: {
      name: "许可证",
      licenseType: "申请许可证类型",
      contractId: "合同号",
      licensedTo: "客户标识码",
      licensedToCompanyName: "客户名称",
      fromTo: "许可证有效期",
      machineKey: "机器码",
      requestedBy: "申请人",
      createBy: "签发人",
      issuanceTime: "签发时间",
      createdAt: "导入时间",
      requestAt: "申请时间",
      userImported: "导入用户",
      lastIssuanceTime: "最后签发时间",
      countsOfApplication: "申请许可证数量",
      notExpired: "未过期生效的数量",
      total: "总量",
      applySource: "申请来源",
      platformToCreate: "平台创建",
      dingTalkApproval: "钉钉审批",
      purchaseOnline: "在线购买",
      issueSuccessfully: "签发成功",
      issueFailed: "签发失败",
      copyLicense: "复制许可证",
      licenseInformation: "许可证信息",
      purposeOfApplication: "申请用途",
      deploymentWay: "部署方式",
      trial: "试用",
      formal: "正式客户",
      test: "测试",
      saasVersion: "SaaS版",
      allManaged: "全托管",
      privatization: "私有化部署",
      systemAccount: "系统账号",
      all: "全部",
      sevenDayExpire: "七天内失效",
      oneMonthExpire: "一个月内失效",
      threeMonthExpire: "三个月内失效",
      expired: "已失效",
      validity: "许可证期效",
      existingCompany: "已存在公司（包括企业微信集成）",
      activateSuccessfully: "激活成功",
      activateFailed: "激活失败",
      export: "导出（限前200条）",
      notice: "邮件通知（Email）",
      localOcr: "本地OCR",
    },
    console: {
      numStudio: "企业版编辑器数量",
      numFloatingStudio: "浮动授权编辑器数量",
      numBasicRobot: "企业基础版机器人数量",
      numPremiumRobot: "企业高级版机器人数量",
      numFloatingRobot: "浮动授权机器人数量",
      numApp: "企业工作台数量",
      numPdfImage: "文档理解API限额（Pdf Image）",
      numPdfText: "文档理解API限额（Pdf Text）",
      numVicode: "ViCode",
    },
    validate: {
      contractId: "请输入合同号",
      licensedTo: "请输入客户标识码",
      licensedToCompanyName: "请输入客户名称",
      purposeOfApplication: "请选择申请用途",
      validity: "请选择期效",
      licenseType: "请选择申请类型",
      fromTo: "请选择许可证有效期",
      machineKey: "请输入机器码",
      numStudio: "请输入企业版编辑器数量",
      numFloatingStudio: "请输入浮动授权编辑器数量",
      numBasicRobot: "请输入企业基础版机器人数量",
      numPremiumRobot: "请输入企业高级版机器人数量",
      numFloatingRobot: "请输入浮动授权机器人数量",
      numApp: "请输入企业工作台数量",
      numPdfImage: "请输入文档理解API限额（Pdf Image）",
      numPdfText: "请输入文档理解API限额（Pdf Text）",
      numVicode: "请输入ViCode",
      privatization: "请输入私有化部署",
      systemAccount: "请输入系统账号",
      deploymentWay: "请选择部署方式",
    },
  },
};
